var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        { attrs: { "label-position": "top", size: "small" } },
        [
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("GlobalSetObj.waybillNumber") } },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: _vm.$t("collectionCenter.pleaseInput"),
                        },
                        model: {
                          value: _vm.queryForm.params.waybillNumber,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryForm.params, "waybillNumber", $$v)
                          },
                          expression: "queryForm.params.waybillNumber",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("navbar.jiechuTime") } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "datetimerange",
                          "range-separator": "-",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          "default-time": ["00:00:00", "23:59:59"],
                          "start-placeholder": _vm.$t("GlobalSetObj.startDate"),
                          "end-placeholder": _vm.$t("GlobalSetObj.endDate"),
                        },
                        model: {
                          value: _vm.queryForm.params.releaseTime,
                          callback: function ($$v) {
                            _vm.$set(_vm.queryForm.params, "releaseTime", $$v)
                          },
                          expression: "queryForm.params.releaseTime",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 6 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("navbar.ReleaseType") } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                            clearable: "",
                            multiple: "",
                          },
                          model: {
                            value: _vm.queryForm.params.unRestrictTypeList,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.queryForm.params,
                                "unRestrictTypeList",
                                $$v
                              )
                            },
                            expression: "queryForm.params.unRestrictTypeList",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("navbar.RegisterProblemDistance"),
                              value: 1,
                            },
                          }),
                          _c("el-option", {
                            attrs: {
                              label: _vm.$t("navbar.ForcePhoto"),
                              value: 2,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            icon: "el-icon-search",
                            size: "small",
                            type: "primary",
                          },
                          on: { click: _vm.enterSearch },
                        },
                        [_vm._v(_vm._s(_vm.$t("newOrder.search")) + " ")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            icon: "el-icon-refresh-left",
                            size: "small",
                            type: "info",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.resetForm()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("newOrder.reset")) + " ")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            icon: "el-icon-plus",
                            size: "small",
                            type: "primary",
                          },
                          on: { click: _vm.addDeregistration },
                        },
                        [_vm._v(_vm._s(_vm.$t("GlobalSetObj.add")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            icon: "el-icon-download",
                            size: "small",
                            type: "primary",
                          },
                          on: { click: _vm.exportExcel },
                        },
                        [_vm._v(_vm._s(_vm.$t("newOrder.export")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          key: _vm.tableKey,
          ref: "restrictionTable",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            "header-cell-style": { background: "#f2f2f2", color: "black" },
            border: "",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("GlobalSetObj.serial"),
              align: "center",
              type: "index",
              width: "70",
            },
          }),
          _vm._l(_vm.tableHeaderList, function (item) {
            return _c("el-table-column", {
              key: item.id,
              attrs: {
                align: item.cloAlign,
                label: item.label,
                "min-width": item.cloWidth,
                prop: item.prop,
                "show-overflow-tooltip": item.isTips,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        item.prop === "statusName"
                          ? _c(
                              "div",
                              [
                                scope.row.status === 1
                                  ? _c("el-tag", [
                                      _vm._v(_vm._s(scope.row.statusName)),
                                    ])
                                  : _c(
                                      "el-tag",
                                      { attrs: { type: "danger" } },
                                      [_vm._v(_vm._s(scope.row.statusName))]
                                    ),
                              ],
                              1
                            )
                          : item.prop === "mustDistanceName"
                          ? _c(
                              "div",
                              [
                                scope.row.mustPic === 1
                                  ? _c("el-tag", [
                                      _vm._v(
                                        _vm._s(_vm.$t("GlobalSetObj.yes"))
                                      ),
                                    ])
                                  : _c(
                                      "el-tag",
                                      { attrs: { type: "danger" } },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("GlobalSetObj.No"))
                                        ),
                                      ]
                                    ),
                              ],
                              1
                            )
                          : _c("div", [
                              _vm._v(
                                _vm._s(
                                  scope.row[item.prop]
                                    ? "" + scope.row[item.prop]
                                    : "- -"
                                )
                              ),
                            ]),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            })
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "right",
              label: _vm.$t("collectionCenter.operation"),
              width: "80",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("el-button", {
                      staticStyle: { color: "#f56c6c", "font-size": "22px" },
                      attrs: {
                        icon: "el-icon-delete",
                        size: "mini",
                        type: "text",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.deleteDeregistration(scope.row)
                        },
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
        ],
        2
      ),
      _c("el-pagination", {
        staticStyle: { margin: "10px 0", float: "right" },
        attrs: {
          "current-page": _vm.queryForm.pageNumber,
          "page-size": _vm.queryForm.pageSize,
          "page-sizes": [10, 20, 50, 100],
          total: _vm.queryForm.total,
          background: "",
          layout: "total, sizes, prev, pager, next, jumper",
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            title: _vm.$t("navbar.xinzengzhanghaoxianzhi"),
            visible: _vm.addDialog,
            top: "5vh",
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.addDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "restrictionLiftedRef",
              attrs: {
                "label-position": "top",
                size: "small",
                model: _vm.restrictionLiftedForm,
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("navbar.jiechuWillybNumber"),
                            prop: "waybillNumbers",
                            rules: [
                              {
                                required: true,
                                message: this.$t("collectionCenter.notNull"),
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.$t("navbar.pasteWaybillNumber"),
                              type: "textarea",
                              rows: "8",
                            },
                            model: {
                              value: _vm.restrictionLiftedForm.waybillNumbers,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.restrictionLiftedForm,
                                  "waybillNumbers",
                                  $$v
                                )
                              },
                              expression:
                                "restrictionLiftedForm.waybillNumbers",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("navbar.rescissionTypeName"),
                            prop: "unRestrictTypeList",
                            rules: [
                              {
                                required: true,
                                message: _vm.$t("collectionCenter.notNull"),
                                trigger: ["blur", "change"],
                              },
                            ],
                          },
                        },
                        [
                          _c(
                            "el-checkbox-group",
                            {
                              model: {
                                value:
                                  _vm.restrictionLiftedForm.unRestrictTypeList,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.restrictionLiftedForm,
                                    "unRestrictTypeList",
                                    $$v
                                  )
                                },
                                expression:
                                  "restrictionLiftedForm.unRestrictTypeList",
                              },
                            },
                            [
                              _c("el-checkbox", { attrs: { label: 1 } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("navbar.RegisterProblemDistance")
                                  )
                                ),
                              ]),
                              _c("el-checkbox", { attrs: { label: 2 } }, [
                                _vm._v(_vm._s(_vm.$t("navbar.ForcePhoto"))),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.addDialog = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.cancel")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.addDeregistrationSubmit },
                },
                [_vm._v(_vm._s(_vm.$t("collectionCenter.confirm")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }